import { Avatar as AntdAvatar } from "antd";
import classNames from "classnames";
import React from "react";

import styles from "./style.module.css";

const Avatar = ({ children, className, testId, ...rest }) => {
  return (
    <AntdAvatar data-testid={testId} {...rest} className={classNames(styles.container, className)}>
      {children}
    </AntdAvatar>
  );
};

export default Avatar;
